<template>
    <Card back >
        <template v-slot:header>
            <h4 class="d-inline">مدیریت دپارتمان های اتوماسیون</h4>
            <hr />
        </template>
        <template v-slot:content>
            <div class="container" :id="$route.name">

                <div v-if="showRowState">
                    <i class="fas Pointer fa-plus text-success h4" @click="changeState(1)"></i>
                </div>

                <div v-else>
                    <i class="fas Pointer fa-times text-danger h4" @click="changeState(0)"></i>
                </div>

                <!-- ------------------------------------------------------- -->

                <Show v-if="showRowState" :propsRows="propsRows" @ChangeState="changeStateFromShow" @Result="result()" :List="List" :tbldepartemnet="tbldepartemnet"/>

                <Add v-if="addRowState" @Result="result()" />

                <Edit v-if="editRowState" :item="editItem" @Result="result()" />

                <AddUser v-if="addUserState" :item="addUserItem" @Result="result()"/>

            </div>
        </template>
    </Card>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Add from './Components/Add.vue'
import Show from './Components/Show.vue'
import Edit from './Components/Edit.vue'
import AddUser from './Components/AddUser.vue'
export default {
    components: { Card, BnpGrid, SearchableCombo, Add, Show, Edit, AddUser },
    data() {
        return {
            propsRows: [],
            showRowState: true,
            addRowState: false,
            editRowState: false,
            addRowState: false,
            addUserState: false,
            editItem: {},
            addUserItem: {}
        }
    },

    mounted() {
        this.getPropsRows()
    },

    methods: {
        changeState(state) {
            if (state == 0) { this.showRowState = true; this.addRowState = false; this.editRowState = false; this.addUserState = false }
            if (state == 1) { this.showRowState = false; this.addRowState = true; this.editRowState = false; this.addUserState = false }
            if (state == 2) { this.showRowState = false; this.addRowState = false; this.editRowState = true; this.addUserState = false }
            if (state == 3) { this.showRowState = false; this.addRowState = false; this.editRowState = false; this.addUserState = true }
        },
        changeStateFromShow(state){
            if (state.state == 2) { this.editItem = state.item }
            if (state.state == 3) { this.addUserItem = state.item }
            if (state.state == 4) { this.$router.push({name:'Workflow',params:{Departement:state.item}}) }
            this.changeState(state.state)
        },
        getPropsRows() {
            this.$PostData_new("get", "AutomationDepartment").then((res) => {
                this.propsRows = res
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در خواندن دپارتمان داد', 'error', 2000)
                console.error(err)
            })
        },

        result() {
            this.changeState(0)
            this.getPropsRows()
        }


    },

    props:['List','tbldepartemnet']

}
</script>